export default [
  require("/home/runner/work/refinery/refinery/node_modules/infima/dist/css/default/default.css"),
  require("/home/runner/work/refinery/refinery/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/home/runner/work/refinery/refinery/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/home/runner/work/refinery/refinery/subprojects/docs/src/css/custom.css"),
];
